import FetchHelper from "./FetchHelper";
import AuthManager from "./AuthManager";
import General from "./General";

export default class Backend {
  static deleteCategory(category) {
    return FetchHelper.delete(window.Api.Categories + "/" + category.id);
  }

  static addCategory(data) {
    return FetchHelper.post(window.Api.Categories, data);
  }

  static getCategories() {
    return FetchHelper.get(window.Api.Categories).then(
      (response) => response.results
    );
  }

  static getFilters(type, categoryId) {
    return FetchHelper.get(
      `${window.Api.Filters}?type=${type}&category_id=${categoryId}&order_by=id`
    ).then((response) => response.results);
  }

  static deleteFilter(data) {
    return FetchHelper.delete(window.Api.Filters + "/" + data.id);
  }

  static addFavouriteFilter(data) {
    data.type = "favourite";
    return FetchHelper.post(window.Api.Filters, data);
  }

  static addEditFilter(data) {
    data.type = "edit";
    return FetchHelper.post(window.Api.Filters, data);
  }

  static addFilterToCategory(data) {
    data.type = "in_category";
    return FetchHelper.post(window.Api.Filters, data);
  }

  static getProject(id) {
    return FetchHelper.get(window.Api.Projects + "/" + id);
  }

  static async updateProject(project, data) {
    data = General.clone(data);
    let image = data.state.data.image;
    if (image.original.startsWith("data:")) {
      let file = General.dataURIToBlob(image.original, "image/png");
      let meta = {
        title: "crop.png",
        width: image.width,
        height: image.height,
      };
      data.state.data.image = await Backend.uploadImage(file, meta);
    }

    delete data.state.data.retouched_image;
    let retouchedImage = data.state.retouched_image;

    if (retouchedImage) {
      if (retouchedImage.original.startsWith("data:")) {
        let file = General.dataURIToBlob(retouchedImage.original, "image/png");
        let meta = {
          title: "retouch.png",
          width: image.width,
          height: image.height,
        };
        data.state.retouched_image = (await Backend.uploadImage(file, meta)).id;
      } else data.state.retouched_image = retouchedImage?.id;
    }

    return FetchHelper.patch(window.Api.Projects + "/" + project.id, data);
  }

  static createProject(data) {
    return FetchHelper.post(window.Api.Projects, data);
  }

  static uploadImage(localFile, meta, onProgress = null) {
    let file = null;

    return Backend.getPresignedUploadUrl(localFile, meta).then((response) => {
      file = response.image;
      return FetchHelper.put(
        response.pre_signed_url,
        localFile,
        false,
        false,
        onProgress
      ).catch((e) => {
        // aws response.json error causes his to trigger v .then
        return Backend.markFileUploaded(file.id, file.token);
      });
    });
  }

  static getPresignedUploadUrl(file, meta) {
    let data = {
      title: meta.title,
    };

    if (meta?.duration) {
      data.duration = Math.round(meta.duration);
    }

    if (meta?.size) {
      data.size = meta.size;
    }

    if (meta?.width) {
      data.width = Math.round(meta.width);
    }

    if (meta?.height) {
      data.height = Math.round(meta.height);
    }

    return FetchHelper.post(window.Api.ImagesV2, data);
  }

  static markFileUploaded(id, token) {
    return FetchHelper.patch(`${window.Api.ImagesV2}/${id}`, {
      token,
      uploaded: true,
    });
  }
}
